import React, { useState } from 'react';

const TechStack = () => {
  const [activeCategory, setActiveCategory] = useState('all');

  const stack = [
    // Mobile
    { name: 'Flutter', category: 'mobile', icon: 'fas fa-mobile-alt', color: '#02569B', desc: 'Cross-platform native iOS & Android apps' },
    { name: 'React Native', category: 'mobile', icon: 'fab fa-react', color: '#61DAFB', desc: 'High-performance hybrid mobile engineering' },
    { name: 'Swift (iOS)', category: 'mobile', icon: 'fab fa-apple', color: '#FA233B', desc: 'Native Apple iOS & iPadOS apps' },
    { name: 'Kotlin (Android)', category: 'mobile', icon: 'fab fa-android', color: '#7F52FF', desc: 'Native Android enterprise apps' },
    { name: 'Ionic & Capacitor', category: 'mobile', icon: 'fas fa-atom', color: '#3880FF', desc: 'Web-first mobile apps' },
    { name: 'Progressive Web Apps', category: 'mobile', icon: 'fas fa-globe', color: '#00D4FF', desc: 'Offline-capable mobile web apps' },

    // Frontend
    { name: 'React.js', category: 'frontend', icon: 'fab fa-react', color: '#61DAFB', desc: 'Interactive SPA & dynamic web interfaces' },
    { name: 'Next.js', category: 'frontend', icon: 'fas fa-cube', color: '#FFFFFF', desc: 'Server-side rendered React frameworks' },
    { name: 'Vue.js', category: 'frontend', icon: 'fab fa-vuejs', color: '#4FC08D', desc: 'Progressive web frontend framework' },
    { name: 'TypeScript', category: 'frontend', icon: 'fas fa-code', color: '#3178C6', desc: 'Type-safe enterprise JavaScript' },
    { name: 'Tailwind CSS', category: 'frontend', icon: 'fas fa-wind', color: '#38BDF8', desc: 'Modern responsive design system' },
    { name: 'Redux Toolkit', category: 'frontend', icon: 'fas fa-layer-group', color: '#764ABC', desc: 'Predictable state management' },

    // Backend
    { name: 'Node.js & Express', category: 'backend', icon: 'fab fa-node-js', color: '#339933', desc: 'High-concurrency microservices APIs' },
    { name: 'Python & FastAPI', category: 'backend', icon: 'fab fa-python', color: '#3776AB', desc: 'AI backends & RESTful microservices' },
    { name: 'Java & Spring Boot', category: 'backend', icon: 'fab fa-java', color: '#ED8B00', desc: 'Enterprise banking & fintech engines' },
    { name: 'Go (Golang)', category: 'backend', icon: 'fas fa-bolt', color: '#00ADD8', desc: 'High-throughput cloud backend services' },
    { name: 'C# & .NET Core', category: 'backend', icon: 'fas fa-terminal', color: '#512BD4', desc: 'Enterprise Microsoft ecosystem platforms' },
    { name: 'GraphQL & REST', category: 'backend', icon: 'fas fa-network-wired', color: '#E10098', desc: 'Unified API aggregation layers' },

    // Cloud & DevOps
    { name: 'Amazon Web Services', category: 'cloud', icon: 'fab fa-aws', color: '#FF9900', desc: 'EC2, S3, Lambda & cloud infrastructure' },
    { name: 'Google Cloud (GCP)', category: 'cloud', icon: 'fab fa-google', color: '#4285F4', desc: 'BigQuery, Vertex AI & GCP engine' },
    { name: 'Microsoft Azure', category: 'cloud', icon: 'fas fa-cloud', color: '#0089D6', desc: 'Enterprise cloud & hybrid computing' },
    { name: 'Docker Containers', category: 'cloud', icon: 'fab fa-docker', color: '#2496ED', desc: 'Containerization & isolated environments' },
    { name: 'Kubernetes (K8s)', category: 'cloud', icon: 'fas fa-dharmachakra', color: '#326CE5', desc: 'Automated container orchestration' },
    { name: 'Terraform IaC', category: 'cloud', icon: 'fas fa-cubes', color: '#844FBA', desc: 'Declarative infrastructure as code' },

    // Databases
    { name: 'PostgreSQL', category: 'database', icon: 'fas fa-database', color: '#4169E1', desc: 'ACID-compliant relational database' },
    { name: 'MongoDB', category: 'database', icon: 'fas fa-leaf', color: '#47A248', desc: 'Scalable NoSQL document database' },
    { name: 'Redis Cache', category: 'database', icon: 'fas fa-memory', color: '#DC382D', desc: 'Ultra-fast in-memory caching' },
    { name: 'MySQL Enterprise', category: 'database', icon: 'fas fa-server', color: '#4479A1', desc: 'Reliable relational storage' },
    { name: 'Elasticsearch', category: 'database', icon: 'fas fa-search', color: '#005571', desc: 'Distributed log & search engine' },
    { name: 'Firebase Firestore', category: 'database', icon: 'fas fa-fire', color: '#FFCA28', desc: 'Realtime cloud database' },

    // AI Models & LLMs
    { name: 'OpenAI (GPT-4o)', category: 'ai', icon: 'fas fa-brain', color: '#10A37F', desc: 'Generative AI & LLM integration' },
    { name: 'Anthropic Claude', category: 'ai', icon: 'fas fa-robot', color: '#D97706', desc: 'Reasoning & long-context AI models' },
    { name: 'LangChain & LlamaIndex', category: 'ai', icon: 'fas fa-link', color: '#00D4FF', desc: 'LLM orchestration & RAG frameworks' },
    { name: 'PyTorch & TensorFlow', category: 'ai', icon: 'fas fa-microchip', color: '#EE4C2C', desc: 'Deep learning model training' },
    { name: 'Hugging Face', category: 'ai', icon: 'fas fa-smile', color: '#FFD21E', desc: 'Open-source AI models & transformers' },
    { name: 'Pinecone Vector DB', category: 'ai', icon: 'fas fa-project-diagram', color: '#8B5CF6', desc: 'Vector search embeddings' },
  ];

  const categories = [
    { id: 'all', label: 'All Technologies' },
    { id: 'mobile', label: 'Mobile App Dev' },
    { id: 'frontend', label: 'Frontend' },
    { id: 'backend', label: 'Backend' },
    { id: 'cloud', label: 'Cloud & DevOps' },
    { id: 'database', label: 'Databases' },
    { id: 'ai', label: 'AI Models & LLMs' },
  ];

  const filteredStack = activeCategory === 'all' 
    ? stack 
    : stack.filter(t => t.category === activeCategory);

  return (
    <section
      id="technologies"
      style={{
        padding: '64px 0',
        position: 'relative',
        zIndex: 2,
        background: '#060816',
      }}
    >
      <div className="ht-container">
        {/* Section Header */}
        <div className="section-header">
          <span className="section-tag">OUR TECH STACK</span>
          <h2 className="text-gradient" style={{ fontSize: 'clamp(2.2rem, 3.8vw, 3.2rem)', fontWeight: 800 }}>
            Battle-Tested Modern Technologies
          </h2>
          <p style={{ color: '#A3A8B8', fontSize: '1.1rem', maxWidth: '700px', margin: '14px auto 0 auto' }}>
            We leverage cutting-edge mobile frameworks, robust cloud infrastructure, enterprise databases, and state-of-the-art AI models.
          </p>

          {/* Category Filter Tabs */}
          <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', flexWrap: 'wrap', marginTop: '32px' }}>
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setActiveCategory(cat.id)}
                style={{
                  padding: '10px 22px',
                  borderRadius: '9999px',
                  border: activeCategory === cat.id ? '1px solid #00D4FF' : '1px solid rgba(255, 255, 255, 0.1)',
                  background: activeCategory === cat.id ? 'rgba(0, 212, 255, 0.15)' : 'rgba(255, 255, 255, 0.03)',
                  color: activeCategory === cat.id ? '#00D4FF' : '#A3A8B8',
                  fontSize: '0.88rem',
                  fontWeight: 700,
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  cursor: 'pointer',
                  transition: 'all 0.25s ease',
                  boxShadow: activeCategory === cat.id ? '0 0 20px rgba(0, 212, 255, 0.25)' : 'none',
                }}
              >
                {cat.label}
              </button>
            ))}
          </div>
        </div>

        {/* Tech Grid */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
            gap: '20px',
            marginTop: '48px',
          }}
        >
          {filteredStack.map((tech, idx) => (
            <div
              key={idx}
              className="glass-card"
              style={{
                borderRadius: '20px',
                padding: '24px',
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                background: 'rgba(15, 23, 42, 0.65)',
                border: '1px solid rgba(255, 255, 255, 0.08)',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                cursor: 'pointer',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(30, 41, 59, 0.85)';
                e.currentTarget.style.borderColor = 'rgba(108, 99, 255, 0.4)';
                e.currentTarget.style.transform = 'translateY(-3px)';
                e.currentTarget.style.boxShadow = '0 12px 30px rgba(108, 99, 255, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(15, 23, 42, 0.65)';
                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.08)';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              {/* Icon Container */}
              <div
                style={{
                  width: '46px',
                  height: '46px',
                  borderRadius: '14px',
                  background: 'rgba(255, 255, 255, 0.05)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}
              >
                <i className={tech.icon} style={{ color: tech.color, fontSize: '1.4rem' }}></i>
              </div>

              {/* Text Info */}
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span
                  style={{
                    color: '#FFFFFF',
                    fontWeight: 800,
                    fontSize: '1rem',
                    fontFamily: "'Plus Jakarta Sans', sans-serif",
                    marginBottom: '2px',
                  }}
                >
                  {tech.name}
                </span>
                <span
                  style={{
                    color: '#A3A8B8',
                    fontSize: '0.78rem',
                    lineHeight: 1.4,
                  }}
                >
                  {tech.desc}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechStack;


